import React from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import propTypes from 'prop-types';

import './index.css';

import imageMarker from './imageMarker';
import indexMarker from './indexMarker';
import imageTextMarker from './imageTextMarker';
import locateMarker from './locateMarker';

import classNames from 'classnames';
import {
  sendStatsEvent
} from '../statistics';


export {
  imageMarker,
  indexMarker,
  imageTextMarker
};

// marker类型
const markerFactoryMap = {
  imageMarker,
  indexMarker,
  imageTextMarker,
  locateMarker
};

// line类型
const lineFactoryMap = {
  solidLine,
  dottedLine
};


const DEFAULT_OPTIONS = {
  center: [51.505, -0.09],
  zoom: 17,
  maxZoom: 20,
  attributionControl: false,
  zoomControl: false,
  fitBoundsPadding: [10, 10],
  dragging: true,
  touchZoom: true
};




export default class Map extends React.Component {
  static propTypes = {
    options: propTypes.object,
    markers: propTypes.array,
    lines: propTypes.array,
    renderMarkers: propTypes.bool.isRequired, // 是否渲染 markers
    renderLines: propTypes.bool.isRequired, // 是否渲染 lines
    onClickMarker: propTypes.func
  };

  static defaultProps = {
    options: {},
    markers: [],
    renderMarkers: true,
    lines: [],
    renderLines: true
  };

  constructor(props) {
    super(props);
    this.el = null;
    this.map = null;
  }

  getOptions() {
    let {limitBounds, options} = this.props;
    options = {...DEFAULT_OPTIONS, ...options};
    //是否限制显示的bounds
    if(limitBounds){
      options = {
        ...options,
        minZoom: 2,
        maxBounds: new L.LatLngBounds(new L.LatLng(85, -190), new L.LatLng(-85, 200)),
        maxBoundsViscosity: 1
      };
    }
    return options;
  }

  render() {
    let {className} = this.props;
    let cls = classNames('component-map', className);

    return (<div ref={(node) => this.el = node} className={cls}></div>);
  }

  componentDidMount() {
    this.map = L.map(this.el, this.getOptions());
    this.addMapMoveEvent();

    this._initTileLayer();

    this._renderLayer();
  }

  componentDidUpdate() {
    this._renderLayer();
  }

  addMapMoveEvent(){
    let { onDragEnd, onZoomEnd } = this.props;
    if(onDragEnd){
      this.map.on('dragend', ()=>{
        onDragEnd(this.map, 'drag');
      });
    }
    if(onZoomEnd){
      this.map.on('zoomend', ()=>{
        onZoomEnd(this.map, 'zoom');
      });
    }
  }
  _initTileLayer() {
    let url = 'https://google-proxy.zuzuche.com/vt/lyrs=m&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}&s=Galil&scale=';


    //2018-5-14 临时替换地图瓦片url
    // url = 'https://ditu.google.cn/maps/vt/lyrs=m&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}&s=Galil&scale=';

    let urlTemplate = `${url}${window.devicePixelRatio}`;
    let titleLayer = L.tileLayer(urlTemplate, {
      // subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      maxZoom: 20
    });
    titleLayer.on('tileloadstart', () => {
      sendStatsEvent('trip_maptilelayer_start');
    }).on('tileerror', () => {
      sendStatsEvent('trip_maptilelayer_error');
    });
    titleLayer.addTo(this.map);
  }

  _isMarker(layer) {
    return layer instanceof L.Marker;
  }

  _isLine(layer) {
    return layer instanceof L.Polyline;
  }

  _renderMarkers() {
    let {onClickMarker} = this.props;
    let { markers } = this.props;

    markers.forEach((marker) => {
      let markerFactory = markerFactoryMap[marker.type];
      if (!markerFactory) return;

      marker = markerFactory(marker);
      marker.on('click', function (e) {
        onClickMarker && onClickMarker(e, this);
      });

      marker.addTo(this.map);
    });
  }

  _clearMarkers() {
    this.map.eachLayer((layer) => {
      if (this._isMarker(layer)) {
        layer.remove();
      }
    });
  }

  _renderLines() {
    let {lines} = this.props;

    lines.forEach(line => {
      let lineFactory = lineFactoryMap[line.type] || solidLine;
      line = lineFactory(line);

      line.addTo(this.map);
    });
  }

  _clearLines() {
    this.map.eachLayer((layer) => {
      if (this._isLine(layer)) {
        layer.remove();
      }
    });
  }

  // 使所有marker在试图内（可见）
  _viewAllMarkers() {
    let latLngBounds = [];

    this.map.eachLayer((layer) => {
      if (this._isMarker(layer)) {
        latLngBounds.push(layer.getLatLng());
      }
    });

    if (latLngBounds.length > 1) {
      this.map.fitBounds(latLngBounds, {
        animate: true,
        paddingTopLeft: [40, 50],
        paddingBottomRight: [40, 20]
      });
      return;
    }
    if(latLngBounds.length === 1){
      this.map.panTo(latLngBounds[0]);
      return;
    }
  }

  _renderLayer() {
    let {renderLines, renderMarkers} = this.props;

    if (renderMarkers) {
      this._clearMarkers();
      this._renderMarkers();
      this._viewAllMarkers();
    }

    if (renderLines) {
      this._clearLines();
      this._renderLines();
    }
  }
}



/**
 * config = {
 *   type
 *   latLngs
 * }
 */
function solidLine(config) {
  let line = L.polyline(config.latLngs, {
    color: '#4588f5',
    weight: 4
  });
  return line;
}

function dottedLine(config) {
  let line = L.polyline(config.latLngs, {
    color: '#4588f5',
    weight: 4,
    dashArray: [3, 6],
  });
  return line;
}



// WEBPACK FOOTER //
// ./src/components/Map/index.js